import React from 'react';

const WsjTheme = React.lazy(() => import('./Wsj'));
const PrintWsjTheme = React.lazy(() => import('./PrintWsj'));
const BarronsTheme = React.lazy(() => import('./Barrons'));
const DjriskjournalTheme = React.lazy(() => import('./Djriskjournal'));
const MarketwatchTheme = React.lazy(() => import('./Marketwatch'));
const FnlondonTheme = React.lazy(() => import('./Fnlondon'));
const MansionglobalTheme = React.lazy(() => import('./Mansionglobal'));

const ThemeSelector = ({ theme }) => (
  <>
    <React.Suspense fallback={<></>}>
      {theme === 'wsj' && <WsjTheme />}
      {theme === 'djriskjournal' && <DjriskjournalTheme />}
      {theme === 'print-wsj' && <PrintWsjTheme />}
      {theme === 'barrons' && <BarronsTheme />}
      {theme === 'marketwatch' && <MarketwatchTheme />}
      {theme === 'fnlondon' && <FnlondonTheme />}
      {theme === 'mansionglobal' && <MansionglobalTheme />}
    </React.Suspense>
  </>
);

export default React.memo(ThemeSelector);
